import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import i18n (needs to be bundled ;))
import './i18n';
import {BrowserRouter} from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <BrowserRouter>
            <App/>
        </BrowserRouter>
);

// Mesures de performance uniquement en développement
// Pour envoyer vers un endpoint analytics, remplacer console.log par une fonction de reporting
if (process.env.NODE_ENV !== 'production') {
    reportWebVitals(console.log);
}
